// extracted by mini-css-extract-plugin
module.exports = {"min":"SliderIndicatorsContainer_min__2zKmO","max":"SliderIndicatorsContainer_max__31tWD"};